const searchCN = {
    SEARCH_01:'No contact results founded',
    SEARCH_02:'Check this company other',
    SEARCH_03:'Key Contacts',
    SEARCH_04:'Insufficient balance, please recharge',
    SEARCH_05:'Cancel',
    SEARCH_06:'Recharge',
    SEARCH_07:'Log in to use this feature',
    SEARCH_08:'Back',
    SEARCH_09:'No related company founded.',
    SEARCH_10:'All',
    SEARCH_11:'Please enter the English company name or product keywords.',
    SEARCH_12:'Please enter the keywords.',
    SEARCH_13:'Change other keywords or expand the scope',
    SEARCH_14:'Load More',
    SEARCH_15:'Please select a contact',
    SEARCH_16:'Purchase amount',
    SEARCH_17:'Purchases',
    SEARCH_18:'The number of suppliers',
    SEARCH_19:'January',
    SEARCH_20:'February',
    SEARCH_21:'March',
    SEARCH_22:'April',
    SEARCH_23:'May',
    SEARCH_24:'June',
    SEARCH_25:'July',
    SEARCH_26:'August',
    SEARCH_27:'September',
    SEARCH_28:'October',
    SEARCH_29:'November',
    SEARCH_30:'December',
    SEARCH_31:'Purchase amount(doller)',
    SEARCH_32:'No More',
    SEARCH_33:'Data Already Achieve',
    SEARCH_34:'Added',
    SEARCH_35:'Company News',
    SEARCH_36:'Source',
    SEARCH_37:'Pubdate',
    SEARCH_38:'More News',
    SEARCH_39:'Tweet',
    SEARCH_40:'Attention',
    SEARCH_41:'Fans',
    SEARCH_42:'Influence',
    SEARCH_44:'Time Bracket',
    SEARCH_45:'To',
    SEARCH_46:'Transaction Amount',
    SEARCH_47:'Dollar',
    SEARCH_48:'Number Of Trades',
    SEARCH_49:'Times（Average monthly purchasing times：',
    SEARCH_50:'Times）',
    SEARCH_51:'Average unit price',
    SEARCH_52:'Purchaser Code',
    SEARCH_53:'Purchasing product analysis',
    SEARCH_54:'Procurement of products count up to',
    SEARCH_55:'Category',
    SEARCH_56:'Understand its purchasing products, judge buyer professional matching degree and provide the buyer with other products.',
    SEARCH_57:'Product description',
    SEARCH_58:'Product code',
    SEARCH_59:'Transaction amount（dollar）',
    SEARCH_60:'Purchasing behavior analysis',
    SEARCH_61:'Supplier details',
    SEARCH_62:'During a total of suppliers',
    SEARCH_63:'Times',
    SEARCH_64:'Understanding the global supply chain, to understand the depth of cooperation, to formulate the service strategy.',
    SEARCH_65:'Supplier name',
    SEARCH_66:'Trading volume(KG)',
    SEARCH_67:'Trade share',
    SEARCH_68:'Details of the purchase record',
    SEARCH_69:'Total purchase',
    SEARCH_70:'Time',
    SEARCH_71:'Understand the buyers purchasing subsidiary, grasp the product market price, the enemy and know yourself get twice the result with half the effort.',
    SEARCH_72:'Time of arrival',
    SEARCH_73:'Supplier name',
    SEARCH_74:'Country of origin',
    SEARCH_75:'Commodity code',
    SEARCH_76:'No email result,check for free',
    SEARCH_77:'Please type in the contact name',
    SEARCH_78:'Do not find the contact, please adjust the name and try again',
    SEARCH_79:'Do not find the contact of the company, please adjust the name of the company and try again',
    SEARCH_80:'Company',
    SEARCH_81:'Contact',
    SEARCH_82:'type in the company name',
    OVER_TIMES_TO_PAY:'There\'s no balance left for this month, please recharge!',
    SEARCH_83:'Please type in the contact name',
    SEARCH_84: '*Try enter words in both  search bar to get more specific result'



}
export default searchCN



// WEBPACK FOOTER //
// ./src/lan/en/en_search.js